import { Injectable } from "@angular/core";
import { Firestore, collection, collectionData } from "@angular/fire/firestore";
import { Observable, lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { Messaging } from "../models/messaging.model";

@Injectable({
    providedIn: 'root',
})
export class MessagingService {

    constructor(
        public afs: Firestore
    ) { }

    getAllMessaging() {
        return collectionData(collection(this.afs, "messaging")).pipe(map(data =>{
            const msgs = [];
            data.forEach(qr=>{
              const msg =  this.getMessagingObj(qr);
              msgs.push(msg);
            })
             return msgs;
        }));
    }

    getMessagingObj(qr) {
        const msg = new Messaging();
        msg.type = qr.type;
        msg.label = qr.label;
        msg.templates = qr.templates;
        return msg;
    }

}